import React from "react";
import styled from "@emotion/styled";
import {
  Fonts,
  CardImage,
  Textarea,
  LayoutThreeColumns,
  PlayBtn,
  CodeSquare,
  Youtube as IconYoutube,
  Square,
} from "@modir/icons";
import { Element, useEditor } from "@craftjs/core";
import { Layers } from "@craftjs/layers";

import {
  Text,
  Container,
  Image,
  Columns,
  Youtube,
  Video,
  Box,
} from "@uiComponents";
import { PanelSection } from "../PanelGroup/PanelSection";
import { BuilderContext, IBuilderContext } from "../../providers";

const ToolSetStyled = styled.div`
  padding: 0px 0 10px;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  align-items: stretch;
  position: relative;
`;

const ToolSetItem = styled.div`
  padding: 8px;
  width: 30%;
  margin: 1%;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: flex-start;
  contain: content;
  background-color: rgba(129, 135, 153, 0.07);
  border-radius: 5px;
  opacity: 0.7;
  cursor: grab;

  :hover {
    background-color: rgba(129, 135, 153, 0.1);
  }
`;

const ToolsetIcon = styled.div`
  height: 40px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;

  svg {
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 24px;
    transition: none;
    user-select: none;
    flex-shrink: 0;
  }
`;

const ToolsetText = styled.div`
  text-align: center;
  width: 100%;
  font-size: 12px;
`;

export const ToolboxPanel = () => {
  const {
    enabled,
    connectors: { create },
  } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const { customComponents } =
    React.useContext<IBuilderContext>(BuilderContext);

  return (
    <>
      <PanelSection title="Basic component" defaultOpen={true}>
        <ToolSetStyled>
          <ToolSetItem
            ref={(ref: any) =>
              create(
                ref,
                <Text
                  fontSize="16"
                  textAlign="left"
                  text="Enter some text..."
                />
              )
            }
          >
            <ToolsetIcon>
              <Fonts />
            </ToolsetIcon>
            <ToolsetText>Text</ToolsetText>
          </ToolSetItem>
          <ToolSetItem ref={(ref: any) => create(ref, <Image />)}>
            <ToolsetIcon>
              <CardImage />
            </ToolsetIcon>
            <ToolsetText>Image</ToolsetText>
          </ToolSetItem>
          <ToolSetItem
            ref={(ref: any) =>
              create(
                ref,
                <Element
                  canvas
                  is={Container}
                  background={{ r: 78, g: 78, b: 78, a: 1 }}
                  color={{ r: 0, g: 0, b: 0, a: 1 }}
                  height="300px"
                  width="100%"
                ></Element>
              )
            }
          >
            <ToolsetIcon>
              <Textarea />
            </ToolsetIcon>
            <ToolsetText>Section</ToolsetText>
          </ToolSetItem>
          <ToolSetItem
            ref={(ref: any) =>
              create(ref, <Element canvas is={Columns}></Element>)
            }
          >
            <ToolsetIcon>
              <LayoutThreeColumns />
            </ToolsetIcon>
            <ToolsetText>Columns</ToolsetText>
          </ToolSetItem>

          <ToolSetItem
            ref={(ref: any) =>
              create(
                ref,
                <Element
                  canvas
                  is={Box}
                  backgroundColor={{ r: 78, g: 78, b: 78, a: 1 }}
                  color={{ r: 0, g: 0, b: 0, a: 1 }}
                  height="300px"
                  width="100%"
                ></Element>
              )
            }
          >
            <ToolsetIcon>
              <Square />
            </ToolsetIcon>
            <ToolsetText>Box</ToolsetText>
          </ToolSetItem>
        </ToolSetStyled>
      </PanelSection>
      <PanelSection title="Layout"></PanelSection>
      <PanelSection title="Media">
        <ToolSetStyled>
          <ToolSetItem ref={(ref: any) => create(ref, <Video />)}>
            <ToolsetIcon>
              <PlayBtn />
            </ToolsetIcon>
            <ToolsetText>Video</ToolsetText>
          </ToolSetItem>
          <ToolSetItem
            ref={(ref: any) =>
              create(
                ref,
                <Element canvas is={Youtube} videoId="zE-a5eqvlv8"></Element>
              )
            }
          >
            <ToolsetIcon>
              <IconYoutube />
            </ToolsetIcon>
            <ToolsetText>Youtube</ToolsetText>
          </ToolSetItem>
          <ToolSetItem>
            <ToolsetIcon>
              <CodeSquare />
            </ToolsetIcon>
            <ToolsetText>Embed</ToolsetText>
          </ToolSetItem>
        </ToolSetStyled>
      </PanelSection>

      <PanelSection title="Custom components">
        <ToolSetStyled>
          {customComponents &&
            customComponents.map((item, index) => {
              return (
                <ToolSetItem
                  key={index}
                  ref={(ref: any) => create(ref, item.element)}
                >
                  <ToolsetIcon>{item.icon}</ToolsetIcon>
                  <ToolsetText>{item.name}</ToolsetText>
                </ToolSetItem>
              );
            })}
        </ToolSetStyled>
      </PanelSection>

      <PanelSection title="Layers">
        <ToolSetStyled>
          <Layers expandRootOnLoad={true} />
        </ToolSetStyled>
      </PanelSection>
    </>
  );
};
